import { Grid, LinearProgress } from '@mui/material';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import useModuleMetadata from 'src/hooks/use-module-metadata.hook';
import CollapsibleTable from 'src/components/collapsible-table/collapsible-table';
import { ColumnDef } from '@tanstack/react-table';
import { getBulkInputsTableOpportunity } from '../../store/planner-slice-async-thunks';
import '../../../pricing-simulator/components/list-price-simulation-table/list-price-simulation.scss';
import MODULE_TO_PAGE_MAP from '../../../home/types/simulation-module-to-page-map';
import { IDataItem } from '../../../common/types/data-item';

interface IOpportunitySummaryTableProps {
  rows: IDataItem<any>[];
  columns: ColumnDef<
    {
      [key: string]: string | number;
    },
    unknown
  >[];
}

export default function OpportunitySummaryTable({
  columns,
  rows
}: IOpportunitySummaryTableProps) {
  const { isFetchingOpportunitySummaryData } = useAppSelector(
    (state) => state.plannerV2
  );
  const { sourceId } = useModuleMetadata({
    module: MODULE_TO_PAGE_MAP.PLANNER
  });
  const appDispatch = useAppDispatch();
  const { tableMetadaData } = useAppSelector((state) => state.table);

  const bulkInputsTableOpportunities = useAppSelector(
    (state) => state.plannerV2.bulkInputsTableOpportunities
  );

  return (
    <Grid container>
      {isFetchingOpportunitySummaryData ? (
        <Grid item xs={12}>
          <LinearProgress />
        </Grid>
      ) : null}
      <Grid item xs={12}>
        <div data-testid='opportunity-summary-table'>
          {tableMetadaData && columns.length ? (
            <CollapsibleTable
              setHeightExplicitly={false}
              data={rows}
              columns={columns}
              extClassName='opportunity-summary-table'
            />
          ) : null}
        </div>
      </Grid>
    </Grid>
  );
}
